import { render, staticRenderFns } from "./StandardInputV2.vue?vue&type=template&id=0926c4cd&scoped=true"
import script from "./StandardInputV2.vue?vue&type=script&lang=js"
export * from "./StandardInputV2.vue?vue&type=script&lang=js"
import style0 from "./StandardInputV2.vue?vue&type=style&index=0&id=0926c4cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0926c4cd",
  null
  
)

export default component.exports